import { render } from "./ScaleTareModal.vue?vue&type=template&id=3150ad1c&ts=true"
import script from "./ScaleTareModal.vue?vue&type=script&lang=ts"
export * from "./ScaleTareModal.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__